import { useConfigurationContext } from '@/contexts/ConfigurationContext';
import { Stage } from '@org-avp/avp-hck-dga-customerui-commons';
import type { ShowroomInjectionProps } from '../WebStreaming.types';
import { StreamingStage } from '../WebStreaming.types';

export const injectShowroom = ({ onLoad, scriptSrc }: ShowroomInjectionProps) => {
  const scriptId = 'avp-3dws-deck-script';
  const existingScript = document.getElementById(scriptId);

  if (!existingScript) {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = scriptSrc;
    script.id = scriptId;
    script.onload = () => {
      onLoad(true);
    };
    document.head.appendChild(script);

    return script;
  }

  onLoad(true);

  return existingScript;
};

export const getStreamingStage = (): StreamingStage | '' => {
  const configuration = useConfigurationContext();
  const stage = configuration?.stage ?? Stage.DEV;

  return stage === Stage.DEV ? StreamingStage.PRELIVE_EUC1 : '';
};

export const getShowroomScriptSrc = (stage: Stage): string =>
  stage === Stage.DEV
    ? // for now, we have for dev and prod the same URL
      'https://avp-3dws-deck.eu-west-1-web-streaming.avp.tech/avp-3dws-deck.js'
    : 'https://avp-3dws-deck.eu-west-1-web-streaming.avp.tech/avp-3dws-deck.js';
